/* ==========================================================================
   DS PRO UPGRADE — interaction layer
   Lightweight, dependency-free micro-interactions that make the store feel
   alive and responsive. Everything is feature-flagged via data-* attributes
   set in theme.liquid from the "Pro Upgrade" settings panel, and every block
   is wrapped in try/guards so a failure can never break the storefront.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var cfg = (window.dsUpgrade = window.dsUpgrade || {});
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Button click ripple ----------------------------------------- */
  function initRipple() {
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest(
          '.atc-button, .cart__checkout-button, .button--primary'
        );
        if (!btn || btn.hasAttribute('disabled') || reduceMotion) return;
        var rect = btn.getBoundingClientRect();
        var size = Math.max(rect.width, rect.height);
        var ripple = document.createElement('span');
        ripple.className = 'ds-ripple';
        ripple.style.width = ripple.style.height = size + 'px';
        ripple.style.left = e.clientX - rect.left - size / 2 + 'px';
        ripple.style.top = e.clientY - rect.top - size / 2 + 'px';
        btn.appendChild(ripple);
        setTimeout(function () {
          ripple.remove();
        }, 650);
      },
      false
    );
  }

  /* ---- 2. Scroll reveal ------------------------------------------------ */
  function initReveal() {
    if (!cfg.reveal || reduceMotion || !('IntersectionObserver' in window)) return;
    // Reveal top-level sections inside main content.
    var targets = document.querySelectorAll(
      '#MainContent > .shopify-section > *, #MainContent .shopify-section .ds-reveal-target'
    );
    if (!targets.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ds-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    // A reveal puts a transform on the element. A transform on an ancestor
    // re-anchors position:fixed children to that ancestor, which would make
    // the sticky add-to-cart bar float in the middle of the page. So we must
    // NEVER reveal an element that is, or contains, a fixed/sticky element.
    function isUnsafe(el) {
      if (!el || el.nodeType !== 1) return true;
      var tag = el.tagName;
      if (tag === 'PRODUCT-INFO' || tag === 'STICKY-ATC') return true;
      var pos = window.getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'sticky') return true;
      // Contains a known fixed/sticky widget anywhere inside?
      if (el.querySelector('sticky-atc, .sticky-atc, .ds-stickybar, [data-after-scroll], .product__column-sticky')) {
        return true;
      }
      return false;
    }
    targets.forEach(function (el) {
      // Skip already-animated theme elements, the header, and anything that
      // holds a fixed/sticky element.
      if (el.closest('.section-header') || el.classList.contains('scroll-trigger')) return;
      if (isUnsafe(el)) return;
      el.classList.add('ds-reveal');
      io.observe(el);
    });
  }

  /* ---- 3. Quantity stepper feedback ----------------------------------- */
  function initQtyFeedback() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.quantity__button');
      if (!b) return;
      b.classList.remove('ds-bump');
      // force reflow so the animation can replay
      void b.offsetWidth;
      b.classList.add('ds-bump');
    });
  }

  /* ---- 4. Cart icon bounce + progress bar celebration ----------------- */
  function bounceCartIcon() {
    var icon =
      document.querySelector('#cart-icon-bubble') ||
      document.querySelector('.cart-count-bubble') ||
      document.querySelector('[id^="cart-icon"]');
    if (!icon || reduceMotion) return;
    icon.classList.remove('ds-cart-bounce');
    void icon.offsetWidth;
    icon.classList.add('ds-cart-bounce');
  }

  function watchCart() {
    // PUB/SUB hook (Dawn publishes cart updates) ------------------------
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      try {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
          bounceCartIcon();
          markGoalReached();
        });
      } catch (err) {}
    }
    // Fallback: bounce when any add-to-cart form is submitted -----------
    document.addEventListener('submit', function (e) {
      if (e.target.matches('form[action*="/cart/add"], [data-type="add-to-cart-form"]')) {
        setTimeout(bounceCartIcon, 400);
      }
    });
  }

  function markGoalReached() {
    var bar = document.querySelector('.cart-progress__bar__progress');
    var wrap = document.querySelector('.cart-progress');
    if (!bar || !wrap) return;
    var w = parseFloat(bar.style.width || '0');
    wrap.classList.toggle('ds-goal-reached', w >= 100);
  }

  /* ---- 5. Smooth cart item removal ------------------------------------ */
  function initRemoveAnim() {
    document.addEventListener('click', function (e) {
      var rm = e.target.closest('cart-remove-button button, .cart-remove-button');
      if (!rm || reduceMotion) return;
      var row = rm.closest('.cart-item');
      if (row) row.classList.add('ds-removing');
    });
  }

  /* ---- init ----------------------------------------------------------- */
  /* NOTE: The sticky add-to-cart bar is left entirely to the theme's own
     logic — we no longer set any transition on it, which previously caused
     it to freeze mid-slide on fast scroll. */
  function init() {
    try { initRipple(); } catch (e) {}
    try { initReveal(); } catch (e) {}
    try { initQtyFeedback(); } catch (e) {}
    try { watchCart(); } catch (e) {}
    try { initRemoveAnim(); } catch (e) {}
    try { markGoalReached(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run lightweight hooks after Shopify section re-renders (theme editor)
  document.addEventListener('shopify:section:load', function () {
    try { markGoalReached(); } catch (e) {}
  });
})();
